import * as React from "react";
import { cn } from "../lib/utils";

/** Conteneur d’onglets avec bordure basse (style Programmes / Paramètres). */
export const tabBarListClassName =
  "border-border/60 inline-flex h-auto w-max max-w-full gap-1 overflow-x-auto border-b bg-transparent p-0 pb-px rounded-none";

/** Styles de base d’un onglet (lien, bouton ou Radix trigger). */
export const tabBarTriggerBaseClassName =
  "focus-visible:ring-ring inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-none border-b-2 border-transparent bg-transparent px-3 py-2.5 text-sm font-medium text-foreground/80 shadow-none transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50";

export const tabBarTriggerActiveClassName =
  "border-primary text-primary shadow-none";

export const tabBarTriggerInactiveClassName =
  "border-transparent text-foreground/80 hover:text-foreground";

export function tabBarTriggerClassName(
  active: boolean,
  className?: string,
) {
  return cn(
    tabBarTriggerBaseClassName,
    active ? tabBarTriggerActiveClassName : tabBarTriggerInactiveClassName,
    className,
  );
}

export type TabBarProps = React.ComponentProps<"div">;

export const TabBar = ({ className, ...props }: TabBarProps) => (
  <div
    role="tablist"
    className={cn(tabBarListClassName, className)}
    {...props}
  />
);

export type TabBarButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
};

export const TabBarButton = ({
  active = false,
  className,
  type = "button",
  ...props
}: TabBarButtonProps) => (
  <button
    type={type}
    role="tab"
    aria-selected={active}
    className={tabBarTriggerClassName(active, className)}
    {...props}
  />
);
